/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
], function() {

	class ContentRegistryUtil {
		static getCapabilities(content) {
			let capabilitiesFeature;
			if (content && content.getType()) {
				capabilitiesFeature = content.getFeature(`ContentRegistry.internal.${content.getType()}Capabilities`);
			}
			return capabilitiesFeature;
		}
	}

	return ContentRegistryUtil;
});